import { z } from 'zod';
import { DEFAULT_IMAGE_MODEL, DEFAULT_LLM_MODEL } from '@/shared/catalog/models';
import { TypedStorageKey } from './kv';

export const SettingsSchema = z.object({
  replicateToken: z.string().default(''),
  defaultLlmModel: z.string().default(DEFAULT_LLM_MODEL),
  defaultImageModel: z.string().default(DEFAULT_IMAGE_MODEL),
  defaultImageResolutionPx: z.union([z.literal(1024), z.literal(2048), z.literal(4096)]).default(2048),
  defaultNumImagesPerTemplate: z.number().int().min(1).max(10).default(4),
  concurrencyCap: z.number().int().min(1).max(16).default(4),
  theme: z.enum(['light', 'dark', 'system']).default('dark'),
  acknowledgedTokenWarning: z.boolean().default(false),
});

export type Settings = z.infer<typeof SettingsSchema>;

type SettingsInput = z.input<typeof SettingsSchema>;
export const SETTINGS_KEY = new TypedStorageKey<Settings, SettingsInput>(
  'brand-generator:settings:v1',
  SettingsSchema,
  SettingsSchema.parse({}),
);
